export const windowColors = [
    '#E4E4E4',
    '#71CBA5',
    '#FF8D1F',
    '#E87C8C',
];